// extracted by mini-css-extract-plugin
export var display = "header-module--display--2aLq1";
export var hide = "header-module--hide--BaD1A";
export var dropdownLink = "header-module--dropdownLink--3tQwI";